<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="errorMessage" :mensagem="errorMessage" />


    <div v-if="((!modoEdicao) && (!modoAutorizacao))">
        <div class="form-edit-page row-space">
            <div class="row-end">
                <button type="button" class="buttom-icon--search" @click="lerDados" />
                <button type="button" class="buttom-icon--close" @click="closeForm" />
            </div>
        </div>
        

        <div v-if="lsDados.length>0">
            <div class="table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th class="col-width-char10">Código</th>
                            <th class="col-width-char10">Data</th>
                            <th class="col-width-char30">Bairro</th>
                            <th>Serviço</th>
                            <th class="col-width-char40">Situação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"  @click="visualizarIpOS(obj)">
                            <td class="col-width-char10 right">{{ obj.cdipos }}</td>
                            <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtipos) }}</td>
                            <td class="col-width-char30">{{ obj.nmbairro }}</td>
                            <td>{{ obj.nmipservico }}</td>
                            <td class="col-width-char40">{{ obj.statusnm }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="showPagination" class="pagination">
                <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
                <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
                <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
            </div>
        </div>
        <div v-else>
            <EmptyStateComponent
                title="Nenhuma autorização pendente"
                message="Todas as Ordens de Serviço já foram autorizadas."
            />
        </div>
    </div>


    <div v-if="modoAutorizacao">
        <IpOSViewPage :idView="idView" :ckAutorizacao="true" @close="modoAutorizacao = false" @save="lerDados" />
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericPost } from '@/funcoes/api'; 
import { globalStore } from '@/globals';
import EmptyStateComponent from '@/components/EmptyStateComponent.vue';
import IpOSViewPage from '@/views/cadastros/visualizacoes/IpOSViewPage.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close']);

const errorMessage = ref(null);
const idView = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const modoAutorizacao = ref(false);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);


const closeForm = () => {emit('close');}


const lerDados = async() => {
    try{
        errorMessage.value = null;
        isLoading.value = true;
        const req = await genericPost('/ip/ipos', {
            idmunicipio: globalStore.idmunicipio,
            intparam1: 1});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){errorMessage.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


const visualizarIpOS = (obj) =>{
    idView.value = obj.id;
    modoAutorizacao.value = true;
}

onMounted(lerDados);
</script>
